/** Clave en `noticias_musica.metadata` tras envío carrusel Telegram. */
export const NOTICIA_TELEGRAM_CAROUSEL_SENT_AT = 'telegram_carousel_sent_at';

export function getNoticiaTelegramCarouselSentAt(row) {
  const meta = row?.metadata && typeof row.metadata === 'object' ? row.metadata : {};
  const at = meta[NOTICIA_TELEGRAM_CAROUSEL_SENT_AT];
  return at != null && String(at).trim() ? String(at).trim() : null;
}

/** @returns {{ sent: boolean, label: string, at: string|null }} */
export function noticiaTelegramCarouselSentInfo(row) {
  const at = getNoticiaTelegramCarouselSentAt(row);
  if (!at) return { sent: false, label: 'No', at: null };
  return { sent: true, label: 'Sí', at };
}
